import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { UserPanelComponent } from './user-panel/user-panel.component';
import { PageComponent } from './page/page.component';

// Türkçe karakterler için uppercase/lowercase düzeltmesi
declare global {
    interface String {
        toTurkishUpper(): string;

        toTurkishLower(): string;
    }
}

//noinspection TypeScriptUnresolvedVariable
String.prototype.toTurkishUpper = function(): string {
    let str = this;
    const letters = { 'i': 'İ', 'ş': 'Ş', 'ğ': 'Ğ', 'ü': 'Ü', 'ö': 'Ö', 'ç': 'Ç', 'ı': 'I' };
    str = str.replace(/(([iışğüçö]))/g, (letter: string) => {
        return letters[letter];
    });
    return str.toUpperCase();
};

//noinspection TypeScriptUnresolvedVariable
String.prototype.toTurkishLower = function() {
    let str = this;
    const letters = { 'İ': 'i', 'I': 'ı', 'Ş': 'ş', 'Ğ': 'ğ', 'Ü': 'ü', 'Ö': 'ö', 'Ç': 'ç' };
    str = str.replace(/(([İIŞĞÜÇÖ]))/g, (letter: string) => {
        return letters[letter];
    });
    return str.toLowerCase();
};

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        TohumUiModule
    ],
    declarations: [
        PageComponent,
        UserPanelComponent
    ],
    exports: [
        UserPanelComponent,
        PageComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
